import React, { useState, useEffect } from 'react'
import { TemplateHeaderPreview } from '../main/options/model/types'
import { SelectFile } from './SelectFIle'
import { SelectHistoricalFile } from './SelectHistoricalFile'
import { tabSelected } from './SelectTab'

function ChooseFile({
    setTemplate,
    tab
}: {
    setTemplate: any //(templete: TemplateHeaderPreview) => void
    tab: tabSelected
}) {
    const [fileName, setFileName] = useState<string | undefined>()
    useEffect(() => {
        if (fileName) {
            setTemplate(curr => ({ ...curr, fileName: fileName }))
        }
    }, [fileName])
    return (
        <div>
            {tab.indexOf != -1 ? null : (
                <SelectHistoricalFile
                    setTemplate={setTemplate}
                    tab={tab}
                    fileName={fileName}
                    setFileName={setFileName}
                />
            )}
            <SelectFile setTemplate={setTemplate} setFileName={setFileName} fileName={fileName} />
        </div>
    )
}
export { ChooseFile }
